// src/data/translationPlan.js
// Wochenplan für die „Freie Übersetzung“: wie viele Sätze pro Woche und in welche Richtung.
//
// Richtung: Anfangs wird überwiegend aus der Lernsprache in die Muttersprache übersetzt
// (Spanisch → Deutsch, leichter). Mit dem Kursfortschritt kippt das: ab der Kurshälfte
// gehen 80 % der Sätze von der Muttersprache in die Lernsprache (Deutsch → Spanisch).
// Gemessen am Kursfortschritt, nicht an festen Wochen, damit langsamere Tempi länger
// in der leichten Richtung bleiben.
import { PACE_YEARS } from "./learningConfig";

// Richtungen (bezogen auf den Lernenden, nicht auf eine bestimmte Sprache)
export const TO_LEARNING = "toLearning"; // Muttersprache → Lernsprache (DE → ES)
export const TO_NATIVE = "toNative"; // Lernsprache → Muttersprache (ES → DE)

// Anteil Muttersprache → Lernsprache am Kursanfang und ab FULL_SHARE_AT des Kurses
export const START_SHARE = 0.2;
export const FULL_SHARE = 0.8;
export const FULL_SHARE_AT = 0.5;

// Wochenpensum: Woche 1 = Startwert je Tempo, dann +1 pro Woche bis zum Maximum je Tempo
export const START_SENTENCES_BY_PACE = { hard: 10, medium: 7, easy: 5 };
export const MAX_SENTENCES_BY_PACE = { hard: 20, medium: 15, easy: 10 };

export function getWeeksTotal(pace) {
  const years = PACE_YEARS[pace] ?? PACE_YEARS.medium;
  return Math.round(years * 52);
}

/** Sätze, die in Woche `weekIndex` (ab 1) übersetzt werden sollen. */
export function getTranslationWeekTarget(weekIndex, pace) {
  const week = Math.max(1, weekIndex || 1);
  const start = START_SENTENCES_BY_PACE[pace] ?? START_SENTENCES_BY_PACE.medium;
  const max = MAX_SENTENCES_BY_PACE[pace] ?? MAX_SENTENCES_BY_PACE.medium;
  return Math.min(max, start + week - 1);
}

/** Anteil (0–1) der Sätze Muttersprache → Lernsprache in Woche `weekIndex`. */
export function getToLearningShare(weekIndex, pace) {
  const week = Math.max(1, weekIndex || 1);
  const progress = (week - 1) / getWeeksTotal(pace);
  if (progress >= FULL_SHARE_AT) return FULL_SHARE;
  return START_SHARE + (FULL_SHARE - START_SHARE) * (progress / FULL_SHARE_AT);
}

/**
 * Richtung des `taskIndex`-ten Satzes (ab 0) einer Woche. Verteilt die Richtungen
 * gleichmäßig statt zufällig: bei 20 % ist jeder fünfte Satz Deutsch → Spanisch,
 * bei 3 Sätzen in Woche 1 also der dritte.
 */
export function getDirectionForTask(taskIndex, share) {
  const i = Math.max(0, taskIndex || 0);
  const before = Math.floor(i * share + 0.5);
  const after = Math.floor((i + 1) * share + 0.5);
  return after > before ? TO_LEARNING : TO_NATIVE;
}
